import React, { useState } from "react";
import { Button } from "../ui/button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "../ui/tooltip";

interface DeepFocusTooltipProps {
    content: React.ReactNode;
    children: React.ReactNode;
    action: React.ReactNode;
    handleAction: () => void;
    onOpenChange?: (isOpen: boolean) => void;
}

const DeepFocusTooltip = ({
    content,
    action,
    handleAction,
    children,
    onOpenChange,
}: DeepFocusTooltipProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenChange = (newIsOpen: boolean) => {
        setIsOpen(newIsOpen);
        onOpenChange?.(newIsOpen);
    };

    return (
        <div className="group">
            <TooltipProvider delayDuration={0}>
                <Tooltip open={isOpen}>
                    <TooltipTrigger
                        onClick={() => {
                            handleOpenChange(!isOpen);
                        }}
                    >
                        <div className="p-auto flex h-12 min-w-30 items-center justify-center gap-2 rounded-full bg-surface-dark-deep-focus border border-white/10">
                            {children}
                        </div>
                    </TooltipTrigger>
                    <TooltipContent
                        onPointerLeave={() => {
                            handleOpenChange(false);
                        }}
                    >
                        <div className="flex h-20 w-30 flex-col justify-between gap-2 text-white">
                            <div className="flex h-full items-center justify-center rounded-xl bg-[radial-gradient(rgba(255,255,255,0.2)_1px,transparent_1px)] [background-size:4px_4px]">
                                {content}
                            </div>
                            <Button
                                className="bg-white/20 text-white"
                                onClick={handleAction}
                                variant="secondary"
                            >
                                {action}
                            </Button>
                        </div>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

export default DeepFocusTooltip;
